module.exports = __webpack_public_path__ + "static/media/22ESCWA14.c660c170.jpg";